import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, apiError } from "@/lib/api";
import { formatIsoDay, formatTRY } from "@/lib/format";
import { EmptyRow, LoadingRow } from "@/components/common/States";

export default function CellDialog({ cell, params, onClose }) {
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get("/cashflow-forecast/cell", { params: { ...params, cat: cell.row.key, period: String(cell.period) } }).then(({ data }) => setD(data)).catch((e) => setErr(apiError(e)));
  }, [cell, params]);
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-4xl" aria-describedby={undefined} data-testid="cf-cell-dialog">
        <DialogHeader><DialogTitle>{cell.row.label} · {cell.period === "vadesiz" ? "Vadesiz" : cell.label}</DialogTitle></DialogHeader>
        {err && <div className="text-sm text-rose-600">{err}</div>}
        {d && <div className="text-sm text-slate-600" data-testid="cf-cell-total">{d.count} belge · beklenen {formatTRY(d.total)}</div>}
        <div className="max-h-[60vh] overflow-auto">
          <table className="dense-table w-full">
            <thead><tr><th>Belge</th><th>Cari</th><th>Vade</th><th>Açıklama</th><th className="text-right">Tutar</th><th className="text-right">Beklenen</th></tr></thead>
            <tbody>{!d ? <LoadingRow cols={6} /> : d.items.length === 0 ? <EmptyRow cols={6} /> : d.items.map((x, i) => (
              <tr key={i} data-testid={`cf-cell-item-${i}`}>
                <td className="font-mono text-xs">{x.link ? <Link to={x.link} className="text-blue-700 hover:underline">{x.doc}</Link> : x.doc}</td>
                <td>{x.cari_id ? <Link to={`/cariler/${x.cari_id}`} className="hover:underline">{x.cari}</Link> : x.cari || "—"}</td>
                <td className={x.overdue ? "text-rose-600" : ""}>{formatIsoDay(x.date)}{x.overdue && " (geçmiş)"}</td>
                <td className="text-[12px] text-slate-500">{x.detail}</td>
                <td className="text-right font-mono">{formatTRY(x.amount)}</td>
                <td className="text-right font-mono">{formatTRY(x.expected)}</td>
              </tr>))}</tbody>
          </table>
        </div>
      </DialogContent>
    </Dialog>
  );
}
